<div class="widget-container mb-3" *ngIf="showChart; else noData">
	<sct-charts
		class="chart"
		[id]="chart.title"
		[title]="chart.title"
		[data]="chart.shownData"
		[columnNames]="chart.columnNames"
		[options]="chart.config"
		[type]="'BarChart'"
		[height]="chartHeight"
	></sct-charts>
	<div class="d-flex justify-content-center mt-1" *ngIf="chart.data.length > 10">
		<button class="btn btn-primary" (click)="toggleShowAll()">{{(showAll ? "g.show_less" : "g.show_more") | translate}}</button>
	</div>
</div>

<ng-template #noData>
	<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</ng-template>
